import { IMonHoc } from "../../../model/respone/category/IMonHoc";
import { eMonHocActionTypeIds } from "../../action-types/category/IMonHocActionType";
import { baseAction } from "../IActionBase";

export const monHocAction = {
    loadStart: () => baseAction(eMonHocActionTypeIds.LOAD_START, undefined),
    loadSuccess: (data: IMonHoc[]) => baseAction(eMonHocActionTypeIds.LOAD_SUCCESS, data),
    loadError: (message?: string) => baseAction(eMonHocActionTypeIds.LOAD_ERROR, message),
}